export default __webpack_public_path__ + "static/media/Rory McBryde.825f8113.jpeg";